import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    loanSummaryTitle: {
        id: '_.rbl_loan_summary.loan_summary_title',
        defaultMessage: 'Withdrawal summary'
    },
    withdrawalAmountConfirmation: {
        id: '_.rbl_loan_summary.withdrawal_amount_confirmation',
        defaultMessage: "You're withdrawing:"
    },
    feeAmount: {
        id: '_.rbl_loan_summary.fee_amount',
        defaultMessage: 'Your fixed fee is:'
    },
    noInterest: {
        id: '_.rbl_loan_summary.no_interest',
        defaultMessage: '(No interest at all)'
    },
    feeProportion: {
        id: '_.rbl_loan_summary.fee_proportion',
        defaultMessage: ' of your withdrawal'
    },
    totalRepayment: {
        id: '_.rbl_loan_summary.total_repayment',
        defaultMessage: 'Your total repayment is:'
    },
    discountedOffer: {
        id: '_.rbl_loan_summary.discountedOffer',
        defaultMessage: 'Our offer for you: You save {amount}'
    }
});
